import React, { useEffect, useMemo } from 'react';
import { observer } from 'src/utils/mobx-react';
import { Subtitle, Title, MainWrapper, TextWrapper, DownloadButton, CloseButton } from './DownloadAppBanner.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { CookiebotStateType } from 'src/domains/common/hooks';
import { DownloadAppBannerState } from 'src/domains/layouts/webview/components/downloadAppBanner/DownloadAppBanner.state';

type PropsType = {
    link: string;
    cookiebot: CookiebotStateType;
};

export const DownloadAppBanner = observer('DownloadAppBanner', ({ link, cookiebot }: PropsType) => {
    const state = useMemo(() => new DownloadAppBannerState(cookiebot, link), [cookiebot, link]);

    useEffect(() => {
        return (): void => {
            state.dispose();
        };
    }, [state]);

    if (state.isHidden) return null;

    return (
        <MainWrapper>
            <CloseButton
                onClick={state.handleClose}
                aria-label='Close'
            />
            <UniverseComponent>
                {(universeComponent): React.ReactElement => <universeComponent.downloadAppBannerLogo />}
            </UniverseComponent>
            <TextWrapper>
                <Title>Download Our App</Title>
                <Subtitle>Instant access right from your device.</Subtitle>
            </TextWrapper>
            <DownloadButton
                onClick={state.handleDownload}
                size='xs'
            >
                Get
            </DownloadButton>
        </MainWrapper>
    );
});
